export const TicketRoutes = {
  web: 'web',
  agent: 'agent',
  email: 'email',
  chat: 'chat',
}
export const TicketStatus = {
  open: 'open',
  received: 'received',
  replied: 'replied',
  closed: 'closed',
}
export const TicketStatusJp = {
  open: '新規',
  received: '要返信',
  replied: '返信済み',
  closed: '完了'
}

export const TICKET = 'tickets';
export const ticketConverter = {
  toFirestore(ticket) {
    return {
      ...ticket,
      lastUpdatedAt: new Date()
    }
  },

  fromFirestore(
    snapshot,
    options
  ) {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      ...data,
    }
  }
}